import ProductAttributesBuilder from "./ProductAttributesBuilder";
import Separator from "@/app/components/lib/Separator";
import { fillSelectedAttributes, mergeAttributeKeys } from "./helpers/functions";
import type { IAttiribs, IProductMinimizedData } from "./helpers/interfaces";

const AttributesStepsSelector: React.FC<
  IProductMinimizedData & {
    selectedAttributes: IAttiribs;
    handleAttributesChanged: any;
    unAvailableKeys: IAttiribs;
    outOfStockKeys: IAttiribs;
    disabledKeys: IAttiribs;
    currentAttributeToSelectIdx: number;
    setCurrentAttributeToSelectIdx: React.Dispatch<
      React.SetStateAction<number>
    >;
    attributesMaxWidth?: number;

    allow_user_request_stock_availability_reminder?: boolean;
    show_configurable_attribute_for_all_product?: boolean;
  }
> = ({
  attributes_builder,
  children,
  handleAttributesChanged,
  selectedAttributes,
  unAvailableKeys,
  outOfStockKeys,
  disabledKeys,
  currentAttributeToSelectIdx,
  setCurrentAttributeToSelectIdx,
  attributesMaxWidth,
  allow_user_request_stock_availability_reminder,
  show_configurable_attribute_for_all_product,
  is_configurable,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      {attributes_builder
        .filter((_, idx) => idx < currentAttributeToSelectIdx)
        .map((attr, idx) => {
          const isForcedVisibleOneOption =
            show_configurable_attribute_for_all_product &&
            attr?.data?.length === 1;

          return (
            <div
              key={attr.configurations.key}
              style={
                isForcedVisibleOneOption ? { pointerEvents: "none" } : undefined
              }
            >
              {attr?.data?.length &&
                (attr?.data?.length! > 1 || isForcedVisibleOneOption) && (
                  <Separator
                    startLabel={attr.configurations.title}
                    marginBottom={8}
                  />
                )}
              <ProductAttributesBuilder
                attributesMaxWidth={attributesMaxWidth}
                state={
                  !is_configurable &&
                  isForcedVisibleOneOption &&
                  attr?.data?.[0]?.key
                    ? [attr.data[0].key.toString()]
                    : selectedAttributes[attr.configurations.key] || []
                }
                setState={(state, fromEffect = false) => {
                  handleAttributesChanged(
                    attr.configurations.key,
                    state,
                    true,
                    true,
                  );
                  if (!fromEffect) {
                    setCurrentAttributeToSelectIdx(idx + 1);
                  }
                }}
                productChildren={children}
                attribute={attr}
                unAvailabeKeys={unAvailableKeys[attr.configurations.key] || []}
                outOfStockKeys={outOfStockKeys[attr.configurations.key] || []}
                disabledKeys={disabledKeys[attr.configurations.key] || []}
                isForcedVisibleOneOption={isForcedVisibleOneOption}
              />
            </div>
          );
        })}
      {currentAttributeToSelectIdx < attributes_builder.length &&
        (() => {
          const nextAttr = attributes_builder[currentAttributeToSelectIdx];
          const isForcedVisibleOneOption =
            show_configurable_attribute_for_all_product &&
            nextAttr?.data?.length === 1;

          if (!(nextAttr?.data?.length! > 1 || isForcedVisibleOneOption))
            return null;

          return (
            <div
              style={
                isForcedVisibleOneOption ? { pointerEvents: "none" } : undefined
              }
            >
              <Separator
                startLabel={nextAttr.configurations.title}
                marginBottom={8}
              />
              <ProductAttributesBuilder
                attributesMaxWidth={attributesMaxWidth}
                state={
                  !is_configurable &&
                  isForcedVisibleOneOption &&
                  nextAttr?.data?.[0]?.key
                    ? [nextAttr.data[0].key.toString()]
                    : selectedAttributes[nextAttr.configurations.key] || []
                }
                setState={(attrs) => {
                  const { currentIndex } = fillSelectedAttributes(
                    attributes_builder,
                    currentAttributeToSelectIdx + 1,
                    unAvailableKeys,
                    // Auto-advance must skip disabled values too.
                    mergeAttributeKeys(outOfStockKeys, disabledKeys),
                  );
                  setCurrentAttributeToSelectIdx(currentIndex);
                  handleAttributesChanged(nextAttr.configurations.key, attrs);
                }}
                productChildren={children}
                attribute={nextAttr}
                unAvailabeKeys={
                  unAvailableKeys[nextAttr.configurations.key] || []
                }
                outOfStockKeys={
                  outOfStockKeys[nextAttr.configurations.key] || []
                }
                disabledKeys={disabledKeys[nextAttr.configurations.key] || []}
                allow_user_request_stock_availability_reminder={
                  allow_user_request_stock_availability_reminder
                }
                isForcedVisibleOneOption={isForcedVisibleOneOption}
              />
            </div>
          );
        })()}
    </div>
  );
};

export default AttributesStepsSelector;
